module.exports = __webpack_public_path__ + "img/sun.d9e27faf.svg";